import {Component, OnInit} from '@angular/core';
import {GuestComponent} from "../../../layout/guest/guest.component";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {LoaderService} from '../../../../services/loader/loader.service';
import {PasswordService} from '../../../../services/password-lost/password.service';
import {MetaTitle} from '../../../../decorator/meta-title';
import {NgIf} from '@angular/common';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';
import {passwordValidator} from '../../../../forms/validators/password.validator';

@Component({
  selector: 'app-password-reset',
  imports: [
    GuestComponent,
    ReactiveFormsModule,
    RouterLink,
    NgIf
  ],
  templateUrl: './password-reset.component.html',
  styleUrl: './password-reset.component.scss'
})
@MetaTitle('Password reset')
export class PasswordResetComponent implements OnInit {
  step = '';
  key: string | null = null;

  showPassword: boolean = false;
  showPasswordConfirm: boolean = false;

  form = new FormGroup({
    password: new FormControl('', [Validators.required, passwordValidator]),
    passwordConfirm: new FormControl('', [Validators.required]),
  });

  constructor(
    private loader: LoaderService,
    private passwordService: PasswordService,
    private route: ActivatedRoute,
    private router: Router,
    private snackbar: SnackbarService
  ) {
  }

  ngOnInit(): void {
    this.key = this.route.snapshot.queryParams['key'] ?? null;

    if (!this.key) {
      this.router.navigate(['/login']).then();
      return;
    }

    this.passwordService.passwordCheckKey(this.key).subscribe((valid: boolean) => {
      if (!valid) {
        this.step = 'invalid-key';
      } else {
        this.step = 'form';
      }
    });
  }

  onSubmit(): void {
    if (!this.form.valid || !this.key) {
      return;
    }

    const data: any = this.form.value;

    if (data.password !== data.passwordConfirm) {
      this.snackbar.error('The passwords do not match.', null, 3000);
      return;
    }

    this.loader.startLoading();

    this.passwordService.passwordReset(this.key, data.password).subscribe(() => {
      this.step = 'success';
      this.loader.stopLoading();
    });
  }
}
